/**
 * Smoosh Landing Page — Moms Audience
 * FAQ accordion, fade-in animations, smooth scroll
 */
(function () {
  'use strict';

  // ─── FAQ Accordion ─────────────────────────────────────────────────────────
  document.querySelectorAll('.lp-faq-question').forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('.lp-faq-item');
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.lp-faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      // Toggle current
      if (!isOpen) item.classList.add('open');
    });
  });

  // ─── Scroll-triggered fade-in animations ───────────────────────────────────
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.lp-fade-in').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything
    document.querySelectorAll('.lp-fade-in').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // ─── Smooth scroll for anchor links ────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var offset = 80;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });
})();